import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconRegistry } from '@angular/material/icon';
import {
  EProductCategory,
  ESearchBlockPath,
  IFilters,
  IProductSearchOptions,
  ISearchBlockOptions,
} from '@web-nx-ng-tsc/web-shared-data-access';
import { DomSanitizer } from '@angular/platform-browser';
import { LibSearchBlockService } from '../lib-search-block/lib-search-block.service';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

const SEARCH_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>`;

enum ESearch {
  TYPE = 'type',
  SIZE = 'size',
}

@Component({
  selector: 'web-promo-shared-pattern-lib-model-tire-popup',
  imports: [MatFormFieldModule, MatSelectModule, MatButtonModule],
  templateUrl: './lib-model-tire-popup.component.html',
  styleUrl: './lib-model-tire-popup.component.scss',
})
export class LibModelTirePopupComponent {
  @Input({ required: true }) set nameModel(val: string) {
    this.loggingService.log('@INPUT | nameModel :', val);
    this.model = val;
  }
  @Input({ required: true }) set visibility(val: string) {
    this.loggingService.log('@INPUT | visibility :', val);
    this.visibilitySignal.set(val);
    this.conditionGetData();
  }

  @Output() OnSearch = new EventEmitter();
  @Output() selectedFillterEmit = new EventEmitter();
  @Output() closeClick = new EventEmitter();

  private readonly searchBlockService = inject(LibSearchBlockService);
  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  data: any;
  model!: string;

  visibilitySignal = signal<string>('');
  categorySignal = signal<string | undefined>(undefined);
  isTireSignal = signal<boolean>(true);

  protected readonly defaultOption = 'กรุณาเลือก';
  protected readonly ESearchBlockPath = ESearchBlockPath;
  protected readonly ESearch = ESearch;

  fromProductTire!: boolean;

  selectedWidthSignal = signal<number | string>('');
  selectedHeightSignal = signal<number | string>('');
  selectedSizeSignal = signal<number | string>('');
  selectedTypeSignal = signal<string>('');
  selectedBrandSignal = signal<string>('');
  selectedModelSignal = signal<string>('');
  // highlightsListOption: string[] = [
  //   'ควบคุมบนถนนแห้ง',
  //   'ควบคุมบนถนนเปียก',
  //   'อายุการใช้งาน',
  //   'นุ่มสบาย',
  //   'ความเงียบ',
  //   'ประหยัดน้ำมัน',
  //   'ขับขี่ออฟโรด',
  // ];
  selectedHighlights = signal<string[]>([]);
  selectedTypes = signal<string[]>([]);

  widthListSignal = this.searchBlockService.getWidthListSignal();
  heightListSignal = this.searchBlockService.getHeightListSignal();
  sizeListSignal = this.searchBlockService.getSizeListSignal();
  typeListSignal = this.searchBlockService.getTypeListSignal();
  brandListSignal = this.searchBlockService.getBrandListSignal();
  modelListSignal = this.searchBlockService.getModelListSignal();
  // toppings = new FormControl('');
  highlightsList?: IFilters[];
  typesList?: IFilters[];
  selectedFillter = {
    highlights: [],
    types: [],
  };
  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIconLiteral('search-svg', sanitizer.bypassSecurityTrustHtml(SEARCH_ICON));
  }

  conditionGetData() {
    this.getDataSearchBlock(ESearchBlockPath.WIDTH);
  }

  getDataSearchBlock(input: ESearchBlockPath, options: ISearchBlockOptions = {}) {
    options.model = this.model;
    this.loggingService.log('path', input);
    this.loggingService.log('options', options);
    const category = '1';
    const visibility = this.visibilitySignal();
    // switch (visibility) {
    //   case 'toyo':
    //     options.brand = '1';
    //     break;
    //   case 'nitto':
    //     options.brand = '2';
    //     break;
    //   case 'nankang':
    //     options.brand = '4'; // id brand
    //     break;
    //   default:
    //     break;
    // }
    this.searchBlockService.getDataSearchBlock(category, input, visibility, options).subscribe();
  }

  /**
   * Manage data for GET data dropdown
   * @description if selected dropdown width will send path height by type ESearchBlockPath
   * @param path
   * @param items
   * @example changeSelectedDropdown(eSearchBlockPath.HEIGHT, { width: ${value} }) // value is Two-way binding
   */
  changeSelectedDropdown(path: ESearchBlockPath, items: Record<string, any>) {
    this.loggingService.log('FUNC | changeSelectedDropdown path :', items);
    this.loggingService.log('path', path);

    const category = this.categorySignal();
    const input = `${path}${!this.isTireSignal() ? '-nt' : ''}` as ESearchBlockPath;
    this.loggingService.log('log input bobo :', input);
    let options: ISearchBlockOptions = {};
    switch (path) {
      case ESearchBlockPath.HEIGHT:
        options = {
          width: items['width'],
        };
        this.loggingService.log('SELECT WIDTH GET HEIGHT clear prop height,size');
        this.selectedHeightSignal.set(this.defaultOption);
        this.selectedSizeSignal.set(this.defaultOption);
        this.searchBlockService.clearHeightListSignal();
        this.searchBlockService.clearSizeListSignal();
        break;
      case ESearchBlockPath.SIZE:
        options = {
          width: items['width'],
          height: items['height'],
        };
        this.loggingService.log('SELECT HEIGHT GET SIZE clear prop size');
        this.selectedSizeSignal.set(this.defaultOption);
        // this.searchBlockService.clearSizeListSignal();
        break;
      case ESearchBlockPath.BRAND:
        options = {
          // [`${category}_type`]: items['type'],
          type: items['type'],
        };
        this.loggingService.log('SELECT TYPE GET BRAND clear prop brand,model');
        this.selectedBrandSignal.set(this.defaultOption);
        this.selectedModelSignal.set(this.defaultOption);
        this.searchBlockService.clearBrandListSignal();
        this.searchBlockService.clearModelListSignal();
        break;
      case ESearchBlockPath.MODEL:
        options = {
          // [`${category}_type`]: items['type'],
          // [`${category}_brand`]: items['brand'],
          type: items['type'],
          brand: items['brand'],
        };
        this.loggingService.log('SELECT BRAND GET MODEL clear prop model');
        this.selectedModelSignal.set(this.defaultOption);
        // this.searchBlockService.clearModelListSignal();
        break;
    }
    this.loggingService.log('FUNC | changeSelectedDropdown options:', options);

    this.getDataSearchBlock(input, options);
  }
  onClickSearch() {
    const dataForm: IProductSearchOptions = {
      [`${ESearchBlockPath.WIDTH}`]:
        this.selectedWidthSignal() === this.defaultOption ? '' : this.selectedWidthSignal() || '',
      [`${ESearchBlockPath.HEIGHT}`]:
        this.selectedHeightSignal() === this.defaultOption ? '' : this.selectedHeightSignal() || '',
      [`${ESearchBlockPath.SIZE}`]:
        this.selectedSizeSignal() === this.defaultOption ? '' : this.selectedSizeSignal() || '',
      // [`${ESearchBlockPath.HIGHLIGHTS}`]: this.selectedHighlights()?.length
      //   ? this.selectedHighlights().join(',')
      //   : '',
      // [`${ESearchBlockPath.TYPES}`]: this.selectedTypes()?.length ? this.selectedTypes().join(',') : '',
    };

    this.loggingService.log('FUNC | onClickSearchemit data:', dataForm);

    // Assign to component-level variable if needed
    this.data = dataForm;
    this.search();
  }

  protected readonly EProductCategory = EProductCategory;

  closeDialog() {
    this.closeClick.emit('');
  }
  search() {
    this.OnSearch.emit(this.data);
  }
}
